import { color } from './variable-constants';

export const salesSimBoltOnThemeVariables = {
  '--action-primary': color.vmBlue,
  '--action-primary-shadow': color.shadowBlue,
  '--action-secondary': color.vmBlue
};
